export async function getAliado(arr, id) {
  var infoArray = arr;
  const aliado_Arr = infoArray.filter(
    ({ codigo_aliado }) => codigo_aliado === id
  );
  return aliado_Arr;
}
